import { format } from 'date-fns';
import { AnyObject, TestContext } from 'yup';

export const WEEKS_PER_YEAR = 52;
export const delayMs = (ms: number) =>
    new Promise((res) => setTimeout(res, ms));

export type UniqueTestFn = (
    name: string,
    ctx: TestContext<AnyObject>
) => Promise<boolean>;
export type OnLoadingFn = (loading: boolean) => void;
export function debounceValidation(
    f: UniqueTestFn,
    onLoading: OnLoadingFn,
    interval: number
) {
    let timer: any = null;
    return (value: string, ctx: TestContext<AnyObject>) => {
        onLoading(true);
        clearTimeout(timer);
        return new Promise<boolean>((resolve) => {
            timer = setTimeout(async () => {
                const result = await f(value, ctx);
                onLoading(false);
                resolve(result);
            }, interval);
        });
    };
}

export function formatDateTime(d: Date | string) {
    return {
        day: format(d, 'dd.MM.yyyy'),
        time: format(d, 'HH:mm:ss')
    };
}

export function formatXmlDateTime(d: Date) {
    return format(d, 'yyyy-MM-dd') + 'T' + format(d, 'HH:mm:ss');
}

export function formatXmlDateTimeOpt(d: Date | undefined) {
    if (d) {
        return format(d, 'yyyy-MM-dd') + 'T' + format(d, 'HH:mm:ss');
    }
}
export function formatXmlDateOpt(d: Date | undefined) {
    if (d) {
        return format(d, 'yyyy-MM-dd');
    }
}

export function parseOptDate(s?: string) {
    if (s) {
        try {
            return new Date(s);
        } catch (e) {
            console.error(e);
        }
    }
    return null;
}

export function formatDateTimeDisplay(d: Date | string) {
    const dt = formatDateTime(d);
    return `${dt.day} - ${dt.time}`;
}
